import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import configuration from "../../Utility/config.json";

function HomeUser(props) {
  const auth_url = process.env.REACT_APP_AUTH_URL;
  const entity_url = process.env.REACT_APP_ENTITY_URL;
  const queryParameters =
    entity_url +
    "&returnUrl=" +
    window.location.protocol +
    "//" +
    window.location.host +
    props.subfolder;

  return (
    <div className="container mb-5 mt-3">
      <div className="col-12 col-lg-12 text-center mt-5">
        <div className="card-wrapper card-space">
          <div className="card card-bg card-big">
            <div className="card-body">
              <div className="top-icon">
                <svg className="icon icon-primary">
                  <use href={`${iconSprite}#it-link`} />
                </svg>
              </div>
              <h5 className="card-title">Accedi con SPID o CIE</h5>
              <p className="card-text">Per accedere ai servizi </p>
              <a
                href={
                  auth_url + configuration.AUTH_PATH_LOGIN + queryParameters
                }
                data-element="login"
              >
                <button className="btn btn-primary">clicca qui</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeUser;
